import { AddOnsForm } from '@/components/billing';
import { useCompanyContext } from '@/components/company-shell';

/**
 * Page `/company/:companyId/add-ons` — "Comprar paquete" tab. Reads
 * the shell context and renders the `AddOnsForm` for the loaded
 * company.
 */
export const AddOnsPage = () => {
  const { company, refetch } = useCompanyContext();

  return <AddOnsForm company={company} refetch={refetch} />;
};
